import { ConflictType } from '@standardnotes/responses';
import { ImmutablePayloadCollection, DeltaRemoteRetrieved, DeltaRemoteSaved, DeltaRemoteDataConflicts, DeltaRemoteUuidConflicts, DeltaRemoteRejected, } from '@standardnotes/models';
/**
 * Given a remote sync response, the resolver applies the incoming changes on top
 * of the current base state, and returns what the new global state should look like.
 * The response resolver is purely functional and does not modify global state, but instead
 * offers the 'recommended' new global state given a sync response and a current base state.
 */
export class ServerSyncResponseResolver {
    constructor(payloadSet, baseCollection, payloadsSavedOrSaving, historyMap) {
        this.payloadSet = payloadSet;
        this.baseCollection = baseCollection;
        this.payloadsSavedOrSaving = payloadsSavedOrSaving;
        this.historyMap = historyMap;
    }
    result() {
        const emits = [];
        emits.push(this.processRetrievedPayloads());
        emits.push(this.processSavedPayloads());
        emits.push(this.processUuidConflictUnsavedPayloads());
        emits.push(this.processDataConflictServerPayloads());
        emits.push(this.processRejectedPayloads());
        return emits;
    }
    processSavedPayloads() {
        const delta = new DeltaRemoteSaved(this.baseCollection, this.payloadSet.savedPayloads);
        return delta.result();
    }
    processRetrievedPayloads() {
        const collection = ImmutablePayloadCollection.WithPayloads(this.payloadSet.retrievedPayloads);
        const delta = new DeltaRemoteRetrieved(this.baseCollection, collection, this.payloadsSavedOrSaving, this.historyMap);
        return delta.result();
    }
    getConflictsForType(type) {
        const results = this.payloadSet.conflicts[type] || [];
        return results;
    }
    processDataConflictServerPayloads() {
        const delta = new DeltaRemoteDataConflicts(this.baseCollection, this.getConflictsForType(ConflictType.ConflictingData), this.historyMap);
        return delta.result();
    }
    processUuidConflictUnsavedPayloads() {
        const delta = new DeltaRemoteUuidConflicts(this.baseCollection, this.getConflictsForType(ConflictType.UuidConflict));
        return delta.result();
    }
    processRejectedPayloads() {
        const conflicts = [
            ...this.getConflictsForType(ConflictType.ContentTypeError),
            ...this.getConflictsForType(ConflictType.ContentError),
            ...this.getConflictsForType(ConflictType.ReadOnlyError),
            ...this.getConflictsForType(ConflictType.UuidError),
            ...this.getConflictsForType(ConflictType.SharedVaultSnjsVersionError),
            ...this.getConflictsForType(ConflictType.SharedVaultInsufficientPermissionsError),
            ...this.getConflictsForType(ConflictType.SharedVaultNotMemberError),
            ...this.getConflictsForType(ConflictType.SharedVaultInvalidState),
            ...this.getConflictsForType(ConflictType.InvalidServerItem),
        ];
        const delta = new DeltaRemoteRejected(this.baseCollection, conflicts);
        const result = delta.result();
        return result;
    }
}
